module.exports = __webpack_public_path__ + "img/logo_solana.a07e1e38.png";